<template>
  <paginated-table
    id="admin-payouts-table"
    ref="table"
    endpoint="payouts"
    :columns="columns"
    :label="$t('views.admin.payouts.title')"
    sync-filters-with-url
    :show-generate-csv="false"
  >
    <template #cell(actions)="{ item }">
      <b-dropdown size="sm" variant="white-primary" no-caret toggle-class="mr-0">
        <template #button-content>
          <b-icon icon="three-dots-vertical" /><span class="sr-only">actions</span>
        </template>
        <b-dropdown-item
          v-b-modal="`link-to-kiwili-${item.id}`"
          :variant="item.kiwili_expense_id ? 'warning' : 'success'"
        >
          <b-icon icon="share-fill" />
          {{
            !item.kiwili_expense_id
              ? $t("views.admin.payouts.actions.link_kiwili")
              : $t("views.admin.payouts.actions.edit_kiwili")
          }}
        </b-dropdown-item>
      </b-dropdown>
      <b-modal :id="`link-to-kiwili-${item.id}`" hide-footer hide-header>
        <link-payout-to-kiwili-form
          :payout="item"
          @saved="
            () => {
              $refs.table.refresh();
              $bvModal.hide(`link-to-kiwili-${item.id}`);
            }
          "
        />
      </b-modal>
    </template>
  </paginated-table>
</template>

<script>
import LinkPayoutToKiwiliForm from "@/components/Admin/LinkPayoutToKiwiliForm.vue";
import PaginatedTable from "@/components/shared/PaginatedTable.vue";
import { Column } from "@/components/shared/PaginatedTableColumns";
import { capitalize } from "@/helpers/filters";
import { getCommunityAdminFilter } from "@/helpers/permissions/communities";

export default {
  name: "AdminPayouts",
  components: {
    LinkPayoutToKiwiliForm,
    PaginatedTable,
  },
  computed: {
    columns() {
      return [
        new Column("id", capitalize(this.$t("lists.id")), "id"),
        Column.withRelation(
          "user.full_name",
          capitalize(this.$t("users.fields.user")),
          {
            relation: "users",
            label: "full_name",
            field: "id",
            params: { ...getCommunityAdminFilter(this.user, "read") },
          },
          "user_id",
          {
            urlFct: (item) => `/admin/users/${item.user.id}`,
          }
        ),
        new Column("invoice_id", capitalize(this.$t("views.admin.payouts.columns.invoice")), "id", {
          urlFct: (item) => `/admin/invoices/${item.invoice_id}`,
        }),
        new Column("amount", capitalize(this.$t("views.admin.payouts.columns.total")), "currency"),
        new Column(
          "kiwili_expense_id",
          capitalize(this.$t("views.admin.payouts.columns.kiwili_expense")),
          "text",
          {
            urlFct: (item) =>
              process.env.VUE_APP_KIWILI_BASE_URL
                ? `${process.env.VUE_APP_KIWILI_BASE_URL}/app/depenses/edit/?id=${item.kiwili_expense_id}`
                : null,
          }
        ),
        Column.withSelect(
          "status",
          capitalize(this.$t("views.admin.payouts.columns.status")),
          [
            { value: null, label: capitalize(this.$t("views.admin.payouts.status.all")) },
            {
              value: "linked",
              label: capitalize(this.$t("views.admin.payouts.status.linked")),
              variant: "success",
            },
            {
              value: "unlinked",
              label: capitalize(this.$t("views.admin.payouts.status.unlinked")),
              variant: "warning",
            },
          ],
          { sortable: false }
        ),
        new Column("created_at", capitalize(this.$t("views.admin.payouts.columns.date")), "date"),
      ];
    },
    user() {
      return this.$store.state.user;
    },
  },
  methods: {},
};
</script>

<style lang="scss"></style>
